import React, { useContext } from "react";
import { TenantDetailsContext } from "../TenantDetailsView";
import { Col, Container, Row } from "react-bootstrap";
import ContentData from "../../../../constants/contentFile.json";
import NextIcon from "../../../../assets/images/next-icon.svg";
import DeactiveIcon from "../../../../assets/images/deactiveIcon.png";
import EditIcon from "../../../../assets/images/editIcon.png";
import DeleteIcon from "../../../../assets/images/deleteIcon.png";
import ActiveUserIcon from "../../../../assets/images/activeUserIcon.png";
import "./tenantDetails.css";
import TenantDetailsErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";
import StatusErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";
import DeleteErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";

import Loader from "../../../../components/Loader/Loader";
import StatusToggleBox from "../../../../components/AlertComponent/AlertBox";
import DeleteAlertBox from "../../../../components/AlertComponent/AlertBox";
import DeactivePopupImage from "../../../../assets/images/deactivePopupIcon.svg";
import DeletePopupImage from "../../../../assets/images/delete.svg";
import DeleteSuccessPopup from "../../../../components/PopupAlertSuccess/PopupAlert";
import StatusSuccessPopup from "../../../../components/PopupAlertSuccess/PopupAlert";

const TenantDetails = () => {
  const {
    adminId,
    tenantName,
    tenantEmail,
    tenantPhone,
    tenantOrgName,
    tenantOrgEmail,
    tenantOrgType,
    tenantStatus,
    tenantLocation,
    subscriptionPlan,
    errorPopup,
    setErrorPopup,
    errorAlertMessage,
    spinnerStatus,
    deactivateAlertPopup,
    setDeactivateAlertPopup,
    deleteAlertPopup,
    setDeleteAlertPopup,
    goToTenantEditPage,
    handleTenantDelete,
    deleteSuccessPopup,
    setDeleteSuccessPopup,
    goToTenantListPage,
    statusMessage,
    setStatusMessage,
    popupButtonText,
    setPopupButtonText,
    handleTenantStatus,
    neededStatus,
    setNeededStatus,
    viewTenantDetails,
    statusSuccessPopup,
    setStatusSuccessPopup,
    statusError,
    setStatusError,
    deleteError,
    setDeleteError,
    permissionAccess,

    statusValue,
    buttonText,
    goToLogin,
  } = useContext(TenantDetailsContext);

  return (
    <div className="pageBg">
      <div className="breadCrums">
        <span className="breadCrumsPointing" onClick={goToTenantListPage}>
          {ContentData.viewTenant.tenantManagement}
        </span>
        <img className="nextIcon" src={NextIcon} alt="next icon" />
        <span className="boldBreadCrums">
          {ContentData.viewTenant.pageTitle}
        </span>
      </div>
      <Container className="tenantDetailsContainer">
        {spinnerStatus && <Loader />}
        <div className="flexPage">
          <div className="headFlexing">
            <div className="pageTittles">{tenantName}</div>
            <div className="subFlexing">
              {tenantStatus === "A" ? (
                <div
                  className={`deletEditSection ${
                    permissionAccess?.delete ? "" : "disabledIconOnly"
                  }`}
                  onClick={() => {
                    setStatusMessage(ContentData.tenantPage.deactivateRole);
                    setPopupButtonText(ContentData.tenantPage.deactivate);
                    setNeededStatus("I");
                    setDeactivateAlertPopup(true);
                  }}
                >
                  <img src={DeactiveIcon} alt="DeactiveIcon" />
                </div>
              ) : tenantStatus === "I" ? (
                <div>
                  <span className="activeButton">
                    {ContentData.tenantPage.deactivated}
                  </span>
                  <span
                    className={`deletEditSection ${
                      permissionAccess?.delete ? "" : "disabledIconOnly"
                    }`}
                    onClick={() => {
                      setStatusMessage(ContentData.tenantPage.activateRole);
                      setPopupButtonText(ContentData.tenantPage.activate);
                      setNeededStatus("A");
                      setDeactivateAlertPopup(true);
                    }}
                  >
                    <img src={ActiveUserIcon} alt="ActiveUserIcon" />
                  </span>
                </div>
              ) : null}
              <div
                className={`deletEditSection ${
                  permissionAccess?.edit ? "" : "disabledIconOnly"
                }`}
                onClick={() => goToTenantEditPage(adminId)}
              >
                <img src={EditIcon} alt="EditIcon" />
              </div>
              <div
                className={`deletEditSection ${
                  permissionAccess?.delete ? "" : "disabledIconOnly"
                }`}
                onClick={() => {
                  setDeleteAlertPopup(true);
                }}
              >
                <img src={DeleteIcon} alt="DeleteIcon" />
              </div>
            </div>
          </div>
        </div>
        <div className="basicContainer">
          <div className="viewDetailSection">
            <Row>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.viewTenant.name}</h4>
                    <div className="tenantDetailsData">{tenantName}</div>
                  </div>
                </div>
              </Col>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.addTenant.emailAddress}</h4>
                    <div className="tenantDetailsData">{tenantEmail}</div>
                  </div>
                </div>
              </Col>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.viewTenant.phoneNumber}</h4>
                    <div className="tenantDetailsData">{tenantPhone}</div>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="organisationDetailsTenant">
              {ContentData.viewTenant.organizationDetails}
            </div>
            <Row>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.viewTenant.organizationName}</h4>
                    <div className="tenantDetailsData">{tenantOrgName}</div>
                  </div>
                </div>
              </Col>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.viewTenant.emailAddress}</h4>
                    <div className="tenantDetailsData">{tenantOrgEmail}</div>
                  </div>
                </div>
              </Col>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.viewTenant.type}</h4>
                    <div className="tenantDetailsData">{tenantOrgType}</div>
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.viewTenant.location}</h4>
                    <div className="tenantDetailsData">{tenantLocation}</div>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="organisationDetailsTenant">
              {ContentData.addTenant.subscriptionDetails}
            </div>
            <Row>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.viewTenant.subscriptionPlan}</h4>
                    <div className="tenantDetailsData">{subscriptionPlan}</div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Container>

      <StatusToggleBox
        show={deactivateAlertPopup}
        setShow={setDeactivateAlertPopup}
        alertMessage={statusMessage}
        popImage={DeactivePopupImage}
        handleSubmitData={() => {
          setDeactivateAlertPopup(false);
          handleTenantStatus(adminId, neededStatus);
        }}
        handleCancelClick={() => {
          setDeactivateAlertPopup(false);
        }}
        buttonSubmitText={popupButtonText}
      />

      <DeleteSuccessPopup
        show={deleteSuccessPopup}
        alertMessage={errorAlertMessage}
        handleSubmit={() => {
          goToTenantListPage();
          setDeleteSuccessPopup(false);
        }}
      />
      <StatusSuccessPopup
        show={statusSuccessPopup}
        alertMessage={errorAlertMessage}
        handleSubmit={() => {
          goToTenantListPage();
          setStatusSuccessPopup(false);
        }}
      />
      <DeleteAlertBox
        show={deleteAlertPopup}
        setShow={setDeleteAlertPopup}
        alertMessage={ContentData.tenantPage.deleteRole}
        popImage={DeletePopupImage}
        handleSubmitData={() => {
          handleTenantDelete(adminId);
        }}
        handleCancelClick={() => {
          setDeleteAlertPopup(false);
        }}
        buttonSubmitText={ContentData.tenantPage.delete}
      />

      <TenantDetailsErrorPopup
        show={errorPopup}
        setShow={setErrorPopup}
        alertMessage={errorAlertMessage}
        handleCancel={() => {
          setErrorPopup(false);
        }}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            goToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            viewTenantDetails(adminId);
          }
        }}
        cancelText={ContentData.tenantPage.cancel}
        buttonText={buttonText}
      />
      <StatusErrorPopup
        show={statusError}
        setShow={setStatusError}
        alertMessage={errorAlertMessage}
        handleCancel={() => {
          setStatusError(false);
        }}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            goToLogin();
            setStatusError(false);
          } else {
            setStatusError(false);
            handleTenantStatus(adminId, neededStatus);
          }
        }}
        cancelText={ContentData.tenantPage.cancel}
        buttonText={buttonText}
      />
      <DeleteErrorPopup
        show={deleteError}
        setShow={setDeleteError}
        alertMessage={errorAlertMessage}
        handleCancel={() => {
          setDeleteError(false);
        }}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            goToLogin();
            setDeleteError(false);
          } else {
            setDeleteError(false);
            handleTenantDelete();
          }
        }}
        cancelText={ContentData.tenantPage.cancel}
        buttonText={buttonText}
      />
    </div>
  );
};

export default TenantDetails;
